<template>
  <div style="display: flex">
              <div :style="{'width': showCheckAll ? '35vw' : '100%'}">
    <multiselect
      :multiple="multiselect"
      v-model="value"
      :options="options"
      @input="selectBusiness"
      :custom-label="businessLabel"
      track-by="id"
      label="name"
      :loading="isLoading"
      :internal-search="false"
      :hide-selected="true"
      @search-change="asyncFind"
      selectLabel=""
      :preserveSearch="true"
      :placeholder="$t('Businesses.Filter')"
    >
    </multiselect>
  </div>
  <vs-checkbox v-if="options.length != 0 && showCheckAll" @change="selectChangeAll($event)" style="margin-left: auto" v-model="changeAll">{{
                "modify All"
              }}</vs-checkbox>
  <vs-checkbox v-else-if="showCheckAll" disabled @change="selectChangeAll($event)" style="margin-left: auto" v-model="changeAll">{{
                "modify All"
              }}</vs-checkbox>
  </div>
</template>
<script>
import { businessService } from "../../_services";

export default {
  name: "BusinessSelectFilter",
  data: () => ({
    title: "BusinessSelectFilter",
    options: [],
    value: null,
    isLoading: false,
    changeAll: false
  }),
  props: {
    multiselect: Boolean,
    showCheckAll: Boolean,
  },
  methods: {
    selectBusiness(value, id) {
      this.$emit("selectBusiness", value, false);
      this.changeAll = false;
    },
    selectChangeAll(e) {
      this.$nextTick(() => {
        if(this.changeAll) {
          this.value = null;
          this.$emit("selectChangeAll", this.options, this.changeAll);
        }
        else {
          this.value = null;
          this.$emit("selectChangeAll", this.value, this.changeAll);
        }
      
      })
    },

    businessLabel({ name, city }) {
      return `${name} - ${city}`;
    },
    asyncFind(query) {
      let request = {
        keyword: query,
        perPage: 100,
      };
      // if(query.length > 0){
      this.isLoading = true;
      businessService
        .filter(request)
        .then(
          function (data) {
            this.options = [];

            data.businesses.data.forEach((obj) => {
              this.options.push({ id: obj.id, name: obj.name, city: obj.city });
            });
          }.bind(this)
        )
        .catch(
          function () {
            this.options = [];
          }.bind(this)
        )
        .finally(
          function () {
            this.isLoading = false;
          }.bind(this)
        );
      // }
      // else {
      //   //this.options = [];
      // }
    },
  },
  mounted() {
    this.asyncFind("");
  },
};
</script>
<style>
.multiselect {
  z-index: 999;
  min-width: 230px;
}

.multiselect__option--highlight {
  background-color: #48b7ff;
  outline: none;
  color: #fff;
}

.multiselect__tags {
  min-height: 20px !important;
  display: block;
  padding: 6px 40px 0 8px !important;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 14px;
}
</style>